/**
 * DevExtreme (ui/data_grid/ui.data_grid.utils.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var gridCoreUtils = require("../grid_core/ui.grid_core.utils"),
    normalizeSortingInfo = require("../../data/utils").normalizeSortingInfo;
exports.createGroupFilter = function(path, storeLoadOptions) {
    var i, groups = normalizeSortingInfo(storeLoadOptions.group),
        filter = [];
    for (i = 0; i < path.length; i++) {
        filter.push([groups[i].selector, "=", path[i]])
    }
    if (storeLoadOptions.filter) {
        filter.push(storeLoadOptions.filter)
    }
    return gridCoreUtils.combineFilters(filter)
};



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/data_grid/ui.data_grid.utils.js
// module id = ../../../../devextreme/ui/data_grid/ui.data_grid.utils.js
// module chunks = common